export default __webpack_public_path__ + "static/media/Catamaran-ExtraBold.4cf7a24e.ttf";